import React from 'react';
import { injectIntl } from 'react-intl';
import { toAbsoluteUrl } from '../../../_metronic/_helpers';
import { Button } from '../../components/Button';

function NotFound({ history, intl }) {
  return (
    <div className="d-flex flex-column h-100">
      <div>
        <img
          src={toAbsoluteUrl('/media/logos/logo-login.png')}
          className="mt-6 ml-6"
          width="225px"
          height="80px"
          alt="SenseWorks"
        />
      </div>
      <div className="d-flex flex-column align-items-center justify-content-center">
        <img
          src={toAbsoluteUrl('/media/senseworks/not-found.png')}
          width="300px"
          height="300px"
          alt="SenseWorks"
        />
        <span style={{ fontWeight: 600, color: '#002C40', fontSize: 30 }}>
          {' '}
          {intl.formatMessage({ id: 'NOT_FOUND.TITLE' })}{' '}
        </span>
        <span style={{ fontSize: 22 }}>
          {' '}
          {intl.formatMessage({ id: 'NOT_FOUND.SUBTITLE' })}{' '}
        </span>
        <Button
          classes="mt-3"
          logoSrc={toAbsoluteUrl('/media/svg/senseworks/white-house.svg')}
          title={intl.formatMessage({ id: 'NOT_FOUND.GO_BACK' })}
          onClick={() => history.push('/')}
        />
      </div>
    </div>
  );
}

export default injectIntl(NotFound);
